// This is a global variable which will hold all audio objects.

import AudioStack from './AudioStack'

export default new AudioStack()
